import { ArdoqId } from '@ardoq/api-types';
import { DocumentArchiveContext } from '@ardoq/api-types';
import { AttachmentWithContext } from './types';

const isOrgAttachment = (attachment: AttachmentWithContext) =>
  attachment.context === DocumentArchiveContext.ORG ||
  !attachment.rootWorkspace;

const isWsAttachment = (
  { rootWorkspace }: AttachmentWithContext,
  workspaceId: ArdoqId
) => rootWorkspace === workspaceId;

const isOrgOrWorkspaceAttachment = (
  attachment: AttachmentWithContext,
  workspaceId: ArdoqId
) => isOrgAttachment(attachment) || isWsAttachment(attachment, workspaceId);

const findById = (
  attachments: AttachmentWithContext[],
  id: ArdoqId
): AttachmentWithContext | null =>
  attachments.find(attachment => attachment._id === id) ?? null;

const findByFilename = (
  attachments: AttachmentWithContext[],
  filename: string
): AttachmentWithContext | null =>
  attachments.find(attachment => attachment.filename === filename) ?? null;

const toSelectOption = (attachment: AttachmentWithContext) => ({
  value: attachment._id,
  label: attachment.filename,
});

export const documentArchiveAttachmentOperations = {
  isOrgAttachment,
  isWsAttachment,
  isOrgOrWorkspaceAttachment,
  findById,
  findByFilename,
  toSelectOption,
};
